/**
 * The `/cc/:collectionId` page's localized-link prefix.
 *
 * Eventbrite localizes URLs with a PARENT-LANGUAGE path prefix - `/{language}/`
 * (`/fr/`, `/es/`, `/de/`) - and every region/ country variant collapses onto
 * its parent language (`fr_CA` -> `fr`, `pt_BR` -> `pt`). An `en_*` locale never
 * gets a prefix (the `.com` default).
 *
 * BUGBOT (round 15): the prefix was built from the full underscore locale
 * (`/fr_FR/`, `/es_ES/`), which matches no served route -> 404 on all
 * localized pages. Mirrors eb-ui's `getParentLocale` collapse (used in the
 * legacy `index.tsx` for the i18n catalog: `fr_CA` -> `fr_FR`).
 */
export function languageSubdirectoryFromLocale(
    locale: string | undefined,
    usesLanguageSubdirectory: boolean,
): string {
    if (!locale || !usesLanguageSubdirectory) {
        return '';
    }
    const language = locale.split('_')[0].toLowerCase();
    // An `en_*` locale is the no-prefix default (even if the flag is set).
    if (!language || language === 'en') {
        return '';
    }
    return `/${language}`;
}
